import styled, { css } from 'styled-components'
import { PopupInterface } from 'common/types/entities/popup-interface'
import {
  backgroundCss,
  borderCss,
  boxShadowCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'

interface PopupDialogUiProps
  extends Pick<
    PopupInterface,
    | 'border'
    | 'background'
    | 'boxShadow'
    | 'padding'
    | 'mobileBoxShadow'
    | 'mobileBackground'
    | 'mobileBorder'
    | 'mobilePadding'
    | 'width'
  > {
  maxHeight: string
}

export const PopupDialogUi = styled.div.attrs(() => ({
  'data-testid': 'popup',
}))<PopupDialogUiProps>`
  border-radius: 6px;
  position: relative;
  transition: transform 0.3s ease-out;
  display: block;
  max-width: 1200px; /* need for iframe width detection */
  max-height: ${p => p.maxHeight};

  ${p =>
    p.width
      ? css`
          width: ${p.width}px;
        `
      : css`
          width: 100%;
        `}

  ${borderCss}
  ${paddingsCss}
  ${backgroundCss}
  ${boxShadowCss}
  
    
  ${p => p.theme.phone} {
    width: 350px;

    ${mobilePaddingsCss}
    ${mobileBoxShadowCss}
      ${mobileBackgroundCss}
      ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      width: 350px;

      ${mobilePaddingsCss}
      ${mobileBoxShadowCss}
        ${mobileBackgroundCss}
        ${mobileBorderCss}
    `}
`
